export class RolloutStrategy {
    constructor(init) {
        Object.assign(this, init);
    }
}
//# sourceMappingURL=rollout-strategy.js.map